// @ts-nocheck
/* eslint-enable */
// App
import React from 'react';
import { useSelector } from 'react-redux';

// Lodash
import omit from 'lodash/omit';

// Components
import ListingWrapper from 'app/shared/modules/listing-cards/ListingWrapper';
import ListSkeleton from 'app/shared/modules/MobileSRP/ListingCards/ListSkeleton';

// Misc / utils
import routeUtils from 'app/shared/utils/routeUtils';
import * as S from './styles';

const NearbyAreaListings = ({ currentAreaName }) => {
  // Redux
  const query = useSelector((state) => state.location.current.query);
  const nearbyItems = useSelector((state) => state.listings.nearbyAreas);
  const slug = useSelector((state) => state.filter.search.slug);
  const fetchNearbyListingsComplete = useSelector((state) => state.app.fetchNearbyListingsComplete);

  const makeNearbyUrl = (nearbyItem) => {
    const path = routeUtils.buildAreaPath({
      areaResourceId: nearbyItem.resourceId,
      searchSlug: slug,
    });

    return routeUtils.buildPathWithQuery(path, omit(query, ['border', 'lat', 'lon', 'z', 'page']));
  };

  if (fetchNearbyListingsComplete === false) {
    return <ListSkeleton count={5} />;
  }

  if (fetchNearbyListingsComplete && nearbyItems.length === 0) {
    return null;
  }

  return (
    <>
      {nearbyItems && nearbyItems.length > 0 && (
        <S.NearbyListingsArticle>
          <S.NearbyListingsText>
            If you're able to expand your search outside of <S.BoldText>{currentAreaName}</S.BoldText>, check out
            properties in these nearby areas:
          </S.NearbyListingsText>
          {nearbyItems.map((nearbyItem) => {
            const nearbyAreaName = nearbyItem.name;
            const nearbyAreaListingsCount = nearbyItem.count;
            const nearbyAreaUri = makeNearbyUrl(nearbyItem);

            return (
              <div key={nearbyAreaName}>
                <S.NearbyListingsItem>
                  <S.NearbyListingsAreaLink to={nearbyAreaUri} linkType="underline">
                    {nearbyAreaName}
                  </S.NearbyListingsAreaLink>
                  <S.LightText>
                    {nearbyAreaListingsCount} {nearbyAreaListingsCount === 1 ? 'property' : 'properties'}
                  </S.LightText>
                </S.NearbyListingsItem>
                <S.List>
                  {nearbyItem.listings.map((listing) => {
                    return (
                      <ListingWrapper
                        listing={listing}
                        key={listing.aliasEncoded}
                        triggerLocation="home_details"
                        triggerObject="property_card"
                      />
                    );
                  })}
                </S.List>
              </div>
            );
          })}
        </S.NearbyListingsArticle>
      )}
    </>
  );
};

export default NearbyAreaListings;
